let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_BRANCH": "Create Branch",
    "LBL_VIEW_BRANCH": "View Branch",
    "LBL_BRANCH_NAME": "Branch Name",
    "LBL_BRANCH_CODE": "Branch Code",
    "LBL_TENANT_ID": "Tenant ID",
    "LBL_DEFAULT_BRANCH":"Default Branch",
    "LBL_STATUS":"Status",
    "LBL_UPLOAD_DIR":"Upload Dir",
    "LBL_DESCRIPTION":"Description",
    "LBL_IPADDRESS":"IP Address",
    "LBL_SHOW_MOBILE_APP":"Show in Mobile App",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_BRANCH_TIMEZONE":"Branch Timezone",
    "LBL_SELECT_BRANCH":"Select Branch",
    "LBL_SELECT_USER":"Select User",
    "LBL_ASSOCIATED_USER":"Associated User",
    "LBL_NAME":"Name",
    "LBL_USER_NAME":"User Name",
    "LBL_USER_STATUS":"User Status",
    "LBL_ACTION":"Action",

}

export default language;